import { EventBoxTranslationOptions, EventMarker } from '@hotjar/webapp/features/Playbacks/types';
import { TFunction } from 'i18next';

export const getEventBoxTitle = (
  eventMarker: EventMarker,
  t: TFunction,
  translationOptions: EventBoxTranslationOptions,
): string => {
  switch (eventMarker.type) {
    case 'page':
      if (eventMarker?.is_new_tab) {
        return t('common:player.sidebar.new-tab', { ...translationOptions.page });
      }
      if (eventMarker?.is_visited_tab) {
        return t('common:player.sidebar.visited-tab', { ...translationOptions.page });
      }
      return t('common:player.sidebar.visited');
    case 'input_choice_change':
    case 'select_change':
    case 'key_press':
      return t('common:player.sidebar.changed');
    case 'mouse_click':
      return t('common:player.sidebar.clicked');
    case 'viewport_resize':
      return t('common:player.sidebar.resized-window-to');
    case 'tag_recording':
      return t('common:player.sidebar.event');
    case 'autotag_recording': {
      return eventMarker.subtype
        ? t('common:player.sidebar.feedback')
        : t('common:player.sidebar.behavior');
    }
    default:
      return t('common:player.sidebar.unknown-action');
  }
};
